import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Images } from "../Common/Images";
import { CheckInUser_api } from "../WeeklyCalendar/WeeklyCalendarAPI";
import { formatDateYYYYMMDD } from "../../utils/CommonUtils";
import { useTranslation } from "react-i18next";
function CheckInCheckOutList({
    ZoneId,
    zoneName,
    checkInCheckOutRecords,
    //isLoading,
    closeModal,
    selectedDate,
    onCheckInCheckout,
    onCheckInApiResponse,
    mapAvailable,
    mapAvailableType,

}) {
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation("common");
    const history = useHistory();
    /* ---------------- LOCAL STATE ---------------- */

    const [localRecords, setLocalRecords] = useState([]);

    useEffect(() => {
        setLocalRecords(checkInCheckOutRecords || []);
    }, [checkInCheckOutRecords]);

    /* ---------------- DATE DISPLAY ---------------- */

    const currentDate = new Date();

    // Translate the short month via the app's own dictionary instead of toLocaleDateString,
    // which always returns English (and the JS Intl engine has no Irish "ga" data anyway).
    // Build the stable key from the English long month name, e.g. "june" -> month_3digit_of_june.
    const monthKey = `month_3digit_of_${currentDate
        .toLocaleDateString("en-US", { month: "long" })
        .toLowerCase()}`;
    const formattedOnlyMonthShort = t(monthKey);

    const formattedOnlyDate = currentDate.toLocaleDateString("en-US", {
        day: "numeric",
    });

    /* ---------------- CHECK IN / OUT ---------------- */

    const checkIncheckOut = async (CheckInFlag, zoneId, CheckInDate, spotId, bookingDateStr) => {
        try {
            setIsLoading(true);
            const reqParams = {
                CheckInFlag,
                ZoneId: zoneId,
                CheckInDate,
                SpotId: spotId,
            };

            const response = await CheckInUser_api(reqParams);
            const responseCode = Number(response?.Data?.ResponseCode);

            await onCheckInApiResponse?.({
                response,
                zoneId,
                bookingDateStr: bookingDateStr || formatDateYYYYMMDD(CheckInDate || selectedDate),
                closeModal,
            });

            if (responseCode === 449) {
                return;
            }

            if (responseCode === 200) {

                const updatedFlag = Number(response?.Data?.Records?.CheckInFlag);
                const updatedSpotId = Number(response?.Data?.Records?.SpotId);

                // ✅ Update ONLY local state (what we render)
                setLocalRecords((prev) =>
                    prev.map((item) =>
                        Number(item.SpotId) === updatedSpotId
                            ? { ...item, CheckInFlag: updatedFlag }
                            : item
                    )
                );

                await onCheckInCheckout?.(
                    zoneId,
                    bookingDateStr || formatDateYYYYMMDD(CheckInDate || selectedDate)
                );
            } else {
                console.error("API Failed:", response?.Data?.Message);
            }

        } catch (error) {
            console.error("CheckIn/Out Error:", error);
        }
        finally {
            setIsLoading(false);
        }
    };

    /* ---------------- MAP BUTTON ---------------- */

    const GoToMapButton = ({ zoneId, bookingDateStr }) => (

            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    GotoMapClick(zoneId, bookingDateStr);
                }}
                className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
            >
                <img src={Images.GreenMap} alt="Map" />
                <span>{t("gotomap")}</span>
            </a>
    );

    function GotoMapClick(zoneId, bookingDateStr) {
        if (mapAvailableType === 2 || mapAvailableType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr
            });

        } else {
            history.push("/no-map-available", { zoneId });
        }

    }

    /* ---------------- RENDER ---------------- */

    return (
        <>
            <div
                className="modal fade show d-block ctm-modalscroll-modal"
                id="checkinModal"
                tabIndex="-1"
                aria-hidden="true"
                style={{ backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            >
                {isLoading && (
                                        <div id='preloader'>
                
                                            <img src={Images.LoaderFull} alt="" />
                                        </div>
                                    )}
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                        <div className="ctm-modal-header">            
                        {/* Close */}
                        <div className="close-modal">
                            <img
                                src={Images.Close}
                                alt="close"
                                style={{ cursor: "pointer" }}
                                onClick={async () => {
                                    closeModal();
                                    await onCheckInCheckout?.(
                                        ZoneId,
                                        formatDateYYYYMMDD(selectedDate)
                                    );
                                }}
                            />
                        </div>

                        {/* Title */}
                        <div className="pt-4">
                            <h5 className="popup-title">{t("react_your_check_in")}</h5>
                        </div>

                        {/* Date + Location */}
                        <div className="date-with-credit d-flex align-items-center gap-4 pt-2 position-relative">
                            <div className="current-date">
                                <h5>
                                    {formattedOnlyDate}{" "}
                                    <span>{formattedOnlyMonthShort}.</span>
                                </h5>
                            </div>

                            <div className="location-info">
                                <img
                                    src={Images.MapOrange}
                                    className="img-fluid"
                                    alt=""
                                />
                                <p>{zoneName}</p>
                            </div>
                        </div>
</div>
                        {/* Table */}
                        <div className="modal-des-table">
                        <div className="checkin-info">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>{t("spot")}</th>
                                        <th>{t("time")}</th>
                                        <th>{t("action")}</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {localRecords.length === 0 && (
                                        <tr>
                                            <td colSpan="3" className="text-center">
                                                {t("react_no_bookings_found")}
                                            </td>
                                        </tr>
                                    )}

                                    {localRecords.map((booking) => {

                                        const flag = Number(booking.CheckInFlag);
                                        const showCheckIn = flag === 0 || flag === 2;
                                        const showCheckOut = flag === 1;
                                        const hasType2 = booking.CheckInType?.includes(2);
                                        return (
                                            <tr key={booking.Id}>
                                                <td>{booking.ParkingBayNumber || booking.SpotName}</td>

                                                <td>
                                                    {booking.BookingTime
                                                        ? booking.BookingTime
                                                        : t("all_day")}
                                                </td>

                                                <td>

                                                    {/* Check In */}
                                                    {(showCheckIn && hasType2 === true) && (
                                                        <button
                                                            type="button"
                                                            className={`fc-checkInBtn-button fc-button fc-button-primary ${isLoading ? "disabled" : ""}`}
                                                            disabled={isLoading}
                                                            style={{ pointerEvents: isLoading ? 'none' : 'auto' }}
                                                            onClick={(e) => {
                                                                if (isLoading) return;
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    checkIncheckOut(
                                                                        1,
                                                                        ZoneId,
                                                                        booking.BookingDate,
                                                                        booking.SpotId,
                                                                        booking.BookingDate
                                                                    )
                                                                }
                                                            }}
                                                        >
                                                            {t("react_check_in")}
                                                        </button>
                                                    )}

                                                    {/* Check Out */}
                                                    {showCheckOut && (
                                                        <button
                                                            type="button"
                                                            className={`fc-checkInBtn-button fc-button fc-button-primary checked-in active ${isLoading ? "disabled" : ""}`}
                                                            disabled={isLoading}
                                                            style={{ pointerEvents: isLoading ? 'none' : 'auto' }}  
                                                            onClick={(e) => {
                                                                if (isLoading) return;
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    checkIncheckOut(
                                                                        2,
                                                                        ZoneId,
                                                                        booking.BookingDate,
                                                                        booking.SpotId,
                                                                        booking.BookingDate
                                                                    )
                                                                }
                                                            }}
                                                        >
                                                            {t("react_check_out")}
                                                        </button>
                                                    )}

                                                </td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        </div>
                        </div>
                        <div className="ctm-modal-footer">            
                        {/* Map Button */}
                        {(mapAvailable === 1 && mapAvailableType !== 1) && (
                            <GoToMapButton
                                zoneId={ZoneId}
                                bookingDateStr={selectedDate}
                            />
                        )}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CheckInCheckOutList;
